'use strict';

//dependencies included for running in node
if (typeof exports !== 'undefined') {
	if (typeof module !== 'undefined' && module.exports) {
    var AdvDate = require('js-utils/src/util/advDate');
    var Account = require('../model/account');
	}
}

var TargetFundSolver = function (p) {
  this.monthsToRetirement = p.monthsToRetirement();
  this.salary = p.person.salary;
  this.maximumIterations = p.targetFundSolver.maximumIterations;
  this.account = new Account(p);
  this.solvedEESavingConts = null;
  this.solvedEESavingRate = null;
};

TargetFundSolver.prototype.getFirstGuessSavingsRate = function(targetFundAtRetirement) {
  var savingsRate = targetFundAtRetirement / (this.monthsToRetirement / AdvDate.MONTHS_IN_YEAR * this.salary) / 2;
  return Math.round(savingsRate * 10000) / 10000;
};

TargetFundSolver.prototype.solve = function(targetFundAtRetirement) {
  this.account.futureTerms = true;

  this.account.accumulate();
  var fund = this.account.getFund();
 
  // exit if no target fund
  if (targetFundAtRetirement == 0) {
    this.solvedEESavingRate = 0;
    this.solvedEESavingConts = 0;
    return;
  }

  // exit if even with zero conts, the target is hit (can happen with auto-enrolment)
  this.account.p.person.contributionRate = 0;
  this.account.accumulate();
  fund = this.account.getFund();

  if (targetFundAtRetirement < fund.getValue()) {
    this.solvedEESavingRate = 0;
    this.solvedEESavingConts = 0;
    return;
  }

  var stepSize = null;
  var iterationCount = null;

  this.solvedEESavingRate = this.getFirstGuessSavingsRate(targetFundAtRetirement);
  this.account.p.person.contributionRate = this.solvedEESavingRate;
  this.account.accumulate();
  fund = this.account.getFund();

  stepSize = this.getFirstGuessSavingsRate(targetFundAtRetirement) / 2;
  iterationCount = 0;

  while (iterationCount < this.maximumIterations) {
    if (targetFundAtRetirement > fund.getValue()) {
      this.solvedEESavingRate += stepSize;
      this.account.p.person.contributionRate = this.solvedEESavingRate;
      this.account.accumulate();
      fund = this.account.getFund();
      stepSize = stepSize / 2;
    } else if (targetFundAtRetirement < fund.getValue()) {
      this.solvedEESavingRate -= stepSize;
      this.account.p.person.contributionRate = this.solvedEESavingRate;
      this.account.accumulate();
      fund = this.account.getFund();
      stepSize = stepSize / 2;
    } else {
      stepSize = stepSize / 2;
      break;
    }
    iterationCount++;
  }

  this.solvedEESavingConts = this.solvedEESavingRate * this.salary;
};

//export for node
if (typeof exports !== 'undefined') {
    if (typeof module !== 'undefined' && module.exports) {
        exports = module.exports = TargetFundSolver;
    }
    exports.TargetFundSolver = TargetFundSolver;
}